import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { Link, useNavigate } from 'react-router-dom';
import Slider from "react-slick";
import axios from "axios";
import "../home/Home.css"
import "../experience/Experience.css"
import "../common-component/left-menu-section/LeftSection.css"
import useEmirateFromCoordinates, { BACKEND_URL, fastApiCall, fastApiClient, PLACEHOLDER_IMAGE } from "../common/Common.js";
import { useLocation } from "../../contexts/LocationContext";
// //Navbar and Left Section Images
// import hayatin from '../../assets/images/hayatin.jpg';
// import homeicon from '../../assets/home-images/homeicon.jpg';
// import experienceicon from '../../assets/home-images/experienceicon.jpg';
import businessicon from '../../assets/home-images/businessicon.jpg';
// import plusicon from '../../assets/home-images/plusicon.png';
// import profileicon from '../../assets/home-images/profileicon.png';
import search from '../../assets/home-images/search.png';
// import videos from '../../assets/home-images/videos.png';
// import blogs from '../../assets/home-images/blogs.png';
// import save from '../../assets/home-images/save.png';
// import menu from '../../assets/home-images/menu.png';
import downarrow from '../../assets/home-images/downarrow.png';
import flagicon from '../../assets/home-images/flagicon.png';
//Mid Section
import exploreabudhabi from "../../assets/experience/exploreabudhabi.mp4";
import rightarrow from '../../assets/home-images/right-section-images/rightarrow.png';

import circleleftarrow from '../../assets/experience/circleleftarrow.png';
import circlerightarrow from '../../assets/experience/circlerightarrow.png';

// import redheart from '../../assets/experience/redheart.png';
// import heartplus from '../../assets/experience/heartplus.png';
// import star from '../../assets/experience/star.png';
import xmark from '../../assets/home-images/right-section-images/xmark.png';

import canadaflag from '../../assets/experience/canadaflag.png';
import omanflag from '../../assets/experience/omanflag.png';
import qatarflag from '../../assets/experience/qatarflag.png';
import kuwaitflag from '../../assets/experience/kuwaitflag.png';
import ksaflag from '../../assets/experience/ksaflag.png';
import businessicon1 from '../../assets/experience/businessicon1.png';

// import messageicon from '../../assets/home-images/messageicon.png';
// import bellicon from '../../assets/home-images/bellicon.png';
import campopup from '../../assets/home-images/cam-popup.png';
import vidpopup from '../../assets/home-images/vid-popup.png';
import offerpopup from '../../assets/home-images/offer-popup.png';
import eventpopup from '../../assets/home-images/event-popup.png';
import spotlightpopup from '../../assets/home-images/spotlight-popup.png';
import carouselpopup from '../../assets/home-images/carouselpopup.png';
import Navbar from "../common-component/navbar/Navbar.js";

//rightsection images
import hayatlogo from '../../assets/home-images/right-section-images/hayatlogo.png';
import qr from '../../assets/home-images/right-section-images/qr.png';
import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';
//
const countryicons = [canadaflag, omanflag, qatarflag, kuwaitflag, ksaflag]

// Helper function to calculate discount text - memoized outside component
const getDiscountText = (item, className = "offer-tag") => {
    switch (item.discount_type_id) {
        case 8:
        case 4:
            return <span className={className}>{item.discount_type}</span>;
        case 7:
            return (
                <span className={className}>
                    {item.discount_value ? `${item.discount_value}% OFF` : item.discount_type}
                </span>
            );
        case 5:
            return (
                <span className={className}>
                    Up to {item.discount_value ? `${item.discount_value}% OFF` : ""}
                </span>
            );
        case 1:
            return item.discount_value && item.discount_price && item.coupon_price ? (
                <>
                    <span className="old-price">AED {item.coupon_price}</span>
                    <span className="new-price">AED {item.discount_price}</span>
                    <span className="separator">|</span>
                    <span className={className}>{item.discount_value}% OFF</span>
                </>
            ) : (
                <span className={className}>AED {item.coupon_price}</span>
            );
        case 10:
            // For limited-deals-tag, use simpler format; for offer-tag, use nested structure
            return className === "limited-deals-tag" ? (
                <span className={className}>From AED {item.coupon_price}</span>
            ) : (
                <span className="discount_type_from">
                    From <span className="discount_coupon_price">AED {item.coupon_price}</span>
                </span>
            );
        default:
            return item.discount_type === "Total" ? (
                <span className={className}>{item.discount_value}% OFF</span>
            ) : (
                <span className={className}>{item.discount_type}</span>
            );
    }
};

// Debounce utility
const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

const Experience = () => {
    const navigate = useNavigate();
    const sliderRef = useRef(null);
    const toppicksRef = useRef(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [categories, setCategories] = useState([]); // categories get api state
    const [spotlights, setSpotlights] = useState([]); // spotlights get api state
    const [offers, setOffers] = useState([]); // offer page list get api state
    const [countrypopup, setCountrypopup] = useState(false);
    const [states, setStates] = useState([]); // countrylist get api state
    const [categorylist, setCategorylist] = useState([]); // categorylist Post api state
    // Loading states for shimmer effects
    const [isCategoriesLoading, setIsCategoriesLoading] = useState(true);
    const [isOffersLoading, setIsOffersLoading] = useState(true);
    const [isCategoryListLoading, setIsCategoryListLoading] = useState(true);
    const [isSpotlightsLoading, setIsSpotlightsLoading] = useState(true);
    // Get location from global context
    const { latitude, longitude, selectedState, updateLocation, isLocationLoading, hasRealLocation } = useLocation();
    const [postpopup, setPostpopup] = useState(false);
    const popupRef = useRef(null);
    //NEAR ME DATA FETCH
    const [nearme, setNearMe] = useState([]);
    const [isNearMeLoading, setIsNearMeLoading] = useState(false);

    // Search functionality states
    const [searchText, setSearchText] = useState("");
    const [vendorList, setVendorList] = useState([]);
    const [allVendors, setAllVendors] = useState([]);
    const [searchCoupons, setSearchCoupons] = useState([]);
    const [searchEvents, setSearchEvents] = useState([]);
    const [allEvents, setAllEvents] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [isSearchFocused, setIsSearchFocused] = useState(false);
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const searchDebounceTimerRef = useRef(null);
    const searchBoxRef = useRef(null);
    const searchDropdownRef = useRef(null);

    // Location is now managed globally by LocationContext - no need for local geolocation
    
    // Log when location changes
    useEffect(() => {
        if (latitude && longitude) {
            console.log('[Experience.js] 📍 Location changed:', {
                latitude,
                longitude,
                isReal: hasRealLocation,
                isLoading: isLocationLoading,
                selectedState: selectedState?.name || 'None'
            });
        }
    }, [latitude, longitude, hasRealLocation, isLocationLoading, selectedState]);

    const emirate = useEmirateFromCoordinates(latitude, longitude);
    // Use default emirate immediately so APIs run with valid state_id from start
    // This prevents empty data on initial render
    const effectiveEmirate = emirate || { name: "Abu Dhabi", id: 1 };

    // Helper function to get search position score (lower score = higher priority)
    const getSearchPositionScore = useCallback((text, searchTerm) => {
        if (!text || !searchTerm) return Infinity;
        const textLower = text.toLowerCase();
        const searchLower = searchTerm.toLowerCase().trim();
        const position = textLower.indexOf(searchLower);
        if (position === -1) return Infinity;
        return position;
    }, []);

    // Filter vendors by search term
    const filterVendorsBySearch = useCallback((vendors, searchValue) => {
        if (!searchValue || searchValue.trim() === "") {
            return vendors;
        }
        const searchLower = searchValue.toLowerCase().trim();
        const filtered = vendors.filter((vendor) => {
            const vendorName = (vendor.vendor_name || vendor.user_name || vendor.name || "").toLowerCase();
            const businessType = (vendor.type_of_business || vendor.business_type || "").toLowerCase();
            const city = (vendor.city || "").toLowerCase();
            return (
                vendorName.includes(searchLower) ||
                businessType.includes(searchLower) ||
                city.includes(searchLower)
            );
        });
        return filtered.sort((a, b) => {
            const aName = (a.vendor_name || a.user_name || a.name || "").toLowerCase();
            const bName = (b.vendor_name || b.user_name || b.name || "").toLowerCase();
            const aBusinessType = (a.type_of_business || a.business_type || "").toLowerCase();
            const bBusinessType = (b.type_of_business || b.business_type || "").toLowerCase();
            const aCity = (a.city || "").toLowerCase();
            const bCity = (b.city || "").toLowerCase();
            const aScore = Math.min(
                getSearchPositionScore(aName, searchLower),
                getSearchPositionScore(aBusinessType, searchLower),
                getSearchPositionScore(aCity, searchLower)
            );
            const bScore = Math.min(
                getSearchPositionScore(bName, searchLower),
                getSearchPositionScore(bBusinessType, searchLower),
                getSearchPositionScore(bCity, searchLower)
            );
            return aScore - bScore;
        });
    }, [getSearchPositionScore]);

    // Fetch vendor list
    const fetchVendorList = useCallback(async (searchValue = "") => {
        const payload = {
            login_user_id: 501,
            search_text: searchValue || ""
        };
        setIsSearchLoading(true);
        try {
            const response = await axios.post(`${BACKEND_URL}website/get-vendor-list`, payload);
            const data = response.data?.data || response.data || [];
            const vendorsArray = Array.isArray(data) ? data : [];
            if (vendorsArray.length > allVendors.length || allVendors.length === 0) {
                setAllVendors(vendorsArray);
            }
            const filteredVendors = filterVendorsBySearch(vendorsArray, searchValue);
            setVendorList(filteredVendors);
        } catch (error) {
            console.error("Error fetching vendor data:", error);
            setVendorList([]);
        } finally {
            setIsSearchLoading(false);
        }
    }, [allVendors.length, filterVendorsBySearch]);

    // Fetch coupons from search-post-list API
    const fetchSearchCoupons = useCallback(async (searchValue = "") => {
        if (!searchValue || searchValue.trim().length === 0) {
            setSearchCoupons([]);
            return;
        }
        const payload = {
            login_user_id: 501,
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
            search: "",
        };
        try {
            const response = await axios.post(`${BACKEND_URL}website/search-post-list`, payload);
            const data = response?.data || {};
            let coupons = [];
            if (Array.isArray(data)) {
                coupons = data.filter(item => item.coupon_id || item.coupon_title || item.discount_type_id);
            } else {
                if (data.coupon_list) {
                    coupons = Array.isArray(data.coupon_list) ? data.coupon_list : [];
                } else if (data.offers) {
                    coupons = Array.isArray(data.offers) ? data.offers : [];
                } else if (data.coupons) {
                    coupons = Array.isArray(data.coupons) ? data.coupons : [];
                }
            }
            const searchLower = searchValue.toLowerCase().trim();
            const filteredCoupons = coupons.filter((coupon) => {
                const couponTitle = String(coupon.coupon_title || "").toLowerCase().trim();
                const userName = String(coupon.user_name || "").toLowerCase().trim();
                return couponTitle.includes(searchLower) || userName.includes(searchLower);
            });
            const sortedCoupons = filteredCoupons.sort((a, b) => {
                const aTitle = (a.coupon_title || "").toLowerCase();
                const bTitle = (b.coupon_title || "").toLowerCase();
                const aName = (a.user_name || "").toLowerCase();
                const bName = (b.user_name || "").toLowerCase();
                const aTitleScore = getSearchPositionScore(aTitle, searchLower);
                const bTitleScore = getSearchPositionScore(bTitle, searchLower);
                const aNameScore = getSearchPositionScore(aName, searchLower);
                const bNameScore = getSearchPositionScore(bName, searchLower);
                const aScore = aTitleScore !== Infinity ? aTitleScore : (aNameScore !== Infinity ? aNameScore + 1000 : Infinity);
                const bScore = bTitleScore !== Infinity ? bTitleScore : (bNameScore !== Infinity ? bNameScore + 1000 : Infinity);
                return aScore - bScore;
            });
            setSearchCoupons(sortedCoupons);
        } catch (error) {
            console.error("Error fetching search coupons:", error);
            setSearchCoupons([]);
        }
    }, [latitude, longitude, getSearchPositionScore]);

    // Fetch events from get-event-list API
    const fetchSearchEvents = useCallback(async (searchValue = "") => {
        const payload = {
            login_user_id: 501,
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
            state_id: selectedState?.id || effectiveEmirate?.id || "",
            user_id: "",
        };
        try {
            const response = await axios.post(`${BACKEND_URL}website/get-event-list`, payload);
            const data = response?.data || [];
            const eventsArray = Array.isArray(data) ? data : [];
            if (eventsArray.length > allEvents.length || allEvents.length === 0) {
                setAllEvents(eventsArray);
            }
            if (!searchValue || searchValue.trim().length === 0) {
                setSearchEvents([]);
                return;
            }
            const searchLower = searchValue.toLowerCase().trim();
            const filteredEvents = eventsArray.filter((event) => {
                const eventTitle = String(event.title || "").toLowerCase().trim();
                return eventTitle.includes(searchLower);
            });
            const sortedEvents = filteredEvents.sort((a, b) => {
                const aTitle = (a.title || "").toLowerCase();
                const bTitle = (b.title || "").toLowerCase();
                const aScore = getSearchPositionScore(aTitle, searchLower);
                const bScore = getSearchPositionScore(bTitle, searchLower);
                return aScore - bScore;
            });
            setSearchEvents(sortedEvents);
        } catch (error) {
            console.error("Error fetching event list:", error);
            setSearchEvents([]);
        }
    }, [latitude, longitude, selectedState, effectiveEmirate, allEvents.length, getSearchPositionScore]);


    // Helper function to get flag icon based on selected state
    const getFlagIcon = useCallback((state) => {
        if (!state) return flagicon;

        // Toronto (id === 9) uses Canada flag
        if (state.id === 9) return countryicons[0]; // Canada
        // Abu Dhabi (id === 1) and Dubai (id === 2) use default flagicon
        if (state.id === 1 || state.id === 2) return flagicon;
        // Oman (id === 5)
        if (state.id === 5) return countryicons[1]; // Oman
        // Qatar (id === 6)
        if (state.id === 6) return countryicons[2]; // Qatar
        // Kuwait (id === 7)
        if (state.id === 7) return countryicons[3]; // Kuwait
        // KSA (id === 8)
        if (state.id === 8) return countryicons[4]; // KSA

        // Default to flagicon for any other state
        return flagicon;
    }, []);

    // Handle location change from country popup
    const handleStateChange = useCallback((state) => {
        // Update location globally via context
        console.log('[Experience.js] 🟢 User selected state:', state.name);
        updateLocation(state);
        setCountrypopup(false);
    }, [updateLocation]);

    // Search handlers
    const handleSearchChange = useCallback((e) => {
        const value = e.target.value;
        setSearchText(value);

        if (value.trim().length > 0) {
            setShowDropdown(true);
        } else {
            setShowDropdown(false);
            if (allVendors.length > 0) {
                setVendorList(allVendors);
            }
            setSearchCoupons([]);
            setSearchEvents([]);
        }

        if (allVendors.length > 0) {
            const filtered = filterVendorsBySearch(allVendors, value);
            setVendorList(filtered);
        }

        if (allEvents.length > 0 && value.trim().length > 0) {
            const searchLower = value.toLowerCase().trim();
            const filteredEvents = allEvents.filter((event) => {
                const eventTitle = String(event.title || "").toLowerCase().trim();
                return eventTitle.includes(searchLower);
            });
            const sortedEvents = filteredEvents.sort((a, b) => {
                const aTitle = (a.title || "").toLowerCase();
                const bTitle = (b.title || "").toLowerCase();
                const aScore = getSearchPositionScore(aTitle, searchLower);
                const bScore = getSearchPositionScore(bTitle, searchLower);
                return aScore - bScore;
            });
            setSearchEvents(sortedEvents);
        } else if (value.trim().length === 0) {
            setSearchEvents([]);
        }

        if (searchDebounceTimerRef.current) {
            clearTimeout(searchDebounceTimerRef.current);
        }

        searchDebounceTimerRef.current = setTimeout(() => {
            fetchVendorList(value);
            fetchSearchCoupons(value);
            fetchSearchEvents(value);
        }, 300);
    }, [allVendors, allEvents, filterVendorsBySearch, getSearchPositionScore, fetchVendorList, fetchSearchCoupons, fetchSearchEvents]);

    const handleSearchEnter = useCallback((e) => {
        if (e.key === "Enter" && searchText.trim().length > 0) {
            navigate(`/searchpage?search=${encodeURIComponent(searchText.trim())}`);
        }
    }, [searchText, navigate]);

    const handleVendorSelect = useCallback((vendor) => {
        const vendorName = vendor.vendor_name || vendor.user_name || vendor.name || "";
        setSearchText(vendorName);
        setShowDropdown(false);
    }, []);

    const handleClearSearch = useCallback(() => {
        setSearchText("");
        setShowDropdown(false);
        setSearchCoupons([]);
        setSearchEvents([]);
        if (allVendors.length > 0) {
            setVendorList(allVendors);
        } else {
            fetchVendorList("");
        }
    }, [allVendors, fetchVendorList]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                searchDropdownRef.current &&
                searchBoxRef.current &&
                !searchDropdownRef.current.contains(event.target) &&
                !searchBoxRef.current.contains(event.target)
            ) {
                setShowDropdown(false);
            }
        };

        if (showDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDropdown]);

    // Initial fetch on component mount
    useEffect(() => {
        fetchVendorList();
        fetchSearchEvents("");
        return () => {
            if (searchDebounceTimerRef.current) {
                clearTimeout(searchDebounceTimerRef.current);
            }
        };
    }, [fetchVendorList, fetchSearchEvents]);

    // SpotLight API data fetch - Optimized with retry logic (similar to Categories API)
    // Sequential API calls when location is ready - displays data as each completes
    useEffect(() => {
        // Wait for location to be ready
        if (isLocationLoading || !latitude || !longitude) {
            return;
        }

        const controller = new AbortController();
        let isCancelled = false;

        const fetchAllLocationData = async () => {
            try {
                // 1. Fetch Offers (most important - main content)
                setIsOffersLoading(true);
                const offersPayload = {
                    latitude: latitude || 24.4539,
                    longitude: longitude || 54.3773,
                    state_id: selectedState?.id || effectiveEmirate?.id || "",
                    user_id: "",
                };
                
                try {
                    const response = await fastApiClient.post(
                        `${BACKEND_URL}website/getofferspagelist`, 
                        offersPayload, 
                        { signal: controller.signal }
                    );
                    
                    if (!isCancelled) {
                        const data = response.data?.data || response.data || [];
                        setOffers(data);
                    }
                } catch (error) {
                    if (error.name !== 'CanceledError' && !isCancelled) {
                        console.error("[Experience.js] ❌ [2/5] Offers Error:", error);
                        setOffers([]);
                    }
                } finally {
                    if (!isCancelled) {
                        setIsOffersLoading(false);
                    }
                }

                // 2. Fetch CategoryList (secondary content)
                setIsCategoryListLoading(true);
                const categoryListPayload = {
                    state_id: selectedState?.id || effectiveEmirate?.id || 1,
                    latitude: latitude || 24.4539,
                    longitude: longitude || 54.3773,
                };

                try {
                    const response = await fastApiClient.post(
                        `${BACKEND_URL}website/get-coupon-list`, 
                        categoryListPayload, 
                        { signal: controller.signal }
                    );
                    
                    if (!isCancelled) {
                        const data = response.data?.data || response.data || [];
                        setCategorylist(data);
                    }
                } catch (error) {
                    if (error.name !== 'CanceledError' && !isCancelled) {
                        console.error("[Experience.js] ❌ [3/5] Category list Error:", error);
                        setCategorylist([]);
                    }
                } finally {
                    if (!isCancelled) {
                        setIsCategoryListLoading(false);
                    }
                }

                // 3. Fetch Near Me (less critical)
                setIsNearMeLoading(true);
                const nearMePayload = {
                    latitude: latitude || 24.4539,
                    longitude: longitude || 54.3773,
                    near_me: true,
                    login_user_id: 501,
                };

                try {
                    const response = await fastApiClient.post(
                        `${BACKEND_URL}website/get-coupon-list`, 
                        nearMePayload, 
                        { signal: controller.signal }
                    );
                    
                    if (!isCancelled) {
                        const data = response.data?.data || response.data || [];
                        setNearMe(data);
                    }
                } catch (error) {
                    if (error.name !== 'CanceledError' && !isCancelled) {
                        console.error("[Experience.js] ❌ [4/5] Near me Error:", error);
                        setNearMe([]);
                    }
                } finally {
                    if (!isCancelled) {
                        setIsNearMeLoading(false);
                    }
                }

                // 4. Fetch Spotlights (can load last)
                setIsSpotlightsLoading(true);
                const spotlightPayload = { login_user_id: 501 };

                try {
                    const response = await axios.post(
                        `${BACKEND_URL}website/get-spotlight-list?_t=${Date.now()}`,
                        spotlightPayload,
                        {
                            signal: controller.signal,
                            timeout: 10000,
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Cache-Control': 'no-cache, no-store, must-revalidate',
                                'Pragma': 'no-cache',
                                'Expires': '0'
                            },
                            withCredentials: false
                        }
                    );

                    if (!isCancelled) {
                        let data = response.data;
                        if (data?.data && Array.isArray(data.data)) {
                            data = data.data;
                        } else if (Array.isArray(data)) {
                            data = data;
                        } else if (data?.spotlights && Array.isArray(data.spotlights)) {
                            data = data.spotlights;
                        } else if (data?.spotlight_list && Array.isArray(data.spotlight_list)) {
                            data = data.spotlight_list;
                        } else {
                            data = [];
                        }
                        setSpotlights(data);
                    }
                } catch (error) {
                    if (error.name !== 'CanceledError' && !isCancelled) {
                        console.error("[Experience.js] ❌ [5/5] Spotlights Error:", error);
                        setSpotlights([]);
                    }
                } finally {
                    if (!isCancelled) {
                        setIsSpotlightsLoading(false);
                    }
                }

            } catch (error) {
                if (!isCancelled) {
                    console.error("[Experience.js] ❌ Sequential fetch error:", error);
                }
            }
        };

        fetchAllLocationData();

        return () => {
            isCancelled = true;
            controller.abort();
        };
    }, [latitude, longitude, effectiveEmirate, selectedState, isLocationLoading]);


    // Category Slider Settings
    const getCategorySlidesToShow = () => {
        const width = window.innerWidth;

        if (width >= 1441) return 4;        // large desktop
        if (width >= 1024) return 3;        // desktop
        if (width >= 769 && width <= 1023) return 3; // tablet - show 3 cards
        if (width >= 320 && width <= 768) return 1.5;  // mobile

        return 1;
    };
    const [categorySlides, setCategorySlides] = useState(getCategorySlidesToShow());

    useEffect(() => {
        const handleResize = debounce(() => {
            setCategorySlides(getCategorySlidesToShow());
        }, 150);

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const discoverdata = useMemo(() => ({
        infinite: false,
        speed: 500,
        slidesToShow: categorySlides,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        arrows: categorySlides >= 3, // arrows only on desktop and tablet
        swipeToSlide: true,
        centerMode: false,
        variableWidth: true, // Add this

        // responsive: [
        //     {
        //         breakpoint: 1024,
        //         settings: {
        //             slidesToShow: 3,
        //             slidesToScroll: 1,
        //             infinite: false,
        //             speed: 500,
        //             touchThreshold: 7,
        //         },
        //     },
        //     {
        //         breakpoint: 768,
        //         settings: {
        //             slidesToShow: 2.5,
        //             slidesToScroll: 1,
        //             infinite: true,
        //             swipeToSlide: true,
        //             speed: 400,
        //             touchThreshold: 5,
        //             centerMode: false,
        //         },
        //     },
        //     {
        //         breakpoint: 480,
        //         settings: {
        //             slidesToShow: 2.5,
        //             slidesToScroll: 1,
        //             infinite: true,
        //             swipeToSlide: true,
        //             speed: 350,
        //             touchThreshold: 5,
        //             centerMode: false,
        //         },
        //     },
        //     {
        //         breakpoint: 360,
        //         settings: {
        //             slidesToShow: 2.5,
        //             slidesToScroll: 1,
        //             infinite: true,
        //             swipeToSlide: true,
        //             speed: 350,
        //             touchThreshold: 5,
        //             centerMode: false,
        //         },
        //     },
        // ],
    }), [categorySlides]);


    //SPOTLIGHT CAROUSEL SLIDER SCREEN CARD TO PRESENT
    const getSpotlightSlidesToShow = (width) => {
        if (width >= 1440) return 5;   // large desktop
        if (width >= 1280) return 4;   // desktop
        if (width >= 768) return 3;    // tablet
        if (width >= 400) return 3;    // mobile large
        return 2;                      // small mobile
    };

    // 🔹 Spotlight: state to store slidesToShow
    const [spotlightSlidesToShow, setSpotlightSlidesToShow] = useState(
        getSpotlightSlidesToShow(window.innerWidth)
    );

    // 🔹 Spotlight: update slides on resize
    useEffect(() => {
        const handleSpotlightResize = () => {
            setSpotlightSlidesToShow(getSpotlightSlidesToShow(window.innerWidth));
        };

        window.addEventListener("resize", handleSpotlightResize);
        return () => window.removeEventListener("resize", handleSpotlightResize);
    }, []);

    const Weeklyspotlightdata = {
        mobileFirst: true,
        infinite: true,
        slidesToShow: spotlightSlidesToShow,
        slidesToScroll: 1,
        rows: 1,
        autoplay: false,
        autoplaySpeed: 3000,

    };


    const getSlidesToShow = () => {
        const width = window.innerWidth;
        if (width >= 1441) return 4;
        if (width >= 993 && width <= 1440) return 3;
        if (width >= 320 && width <= 992) return 1.5;
        return 1; // fallback
    };
    const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow());
    useEffect(() => {
        // Debounced resize handler for better performance
        const handleResize = debounce(() => {
            setSlidesToShow(getSlidesToShow());
        }, 150);

        window.addEventListener("resize", handleResize);

        // call immediately in case dev tools changed width before render
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const unlimitedExperienceSettings = useMemo(() => ({
        infinite: false,
        slidesToShow,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        dots: false,
        initialSlide: 0,
        centerMode: false,
        speed: 500,
        swipeToSlide: false,
        responsive: [],
    }), [slidesToShow]);



    const limitedtimedealsdata = useMemo(() => ({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
    }), []);

    // ViewType6 slider settings - 3x3 grid for desktop, single column for mobile
    const viewType6SliderSettings = useMemo(() => ({
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        arrows: true,
        autoplay: false,
        swipe: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipe: true,
                    swipeToSlide: true,
                },
            },
        ],
    }), []);

    // Helper function to chunk array into groups
    const chunkArray = useCallback((array, chunkSize) => {
        const chunks = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunks.push(array.slice(i, i + chunkSize));
        }
        return chunks;
    }, []);

    // State to track window width for responsive chunking
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = debounce(() => {
            setWindowWidth(window.innerWidth);
        }, 150);

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const handleClickOutside = useCallback((event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setPostpopup(false);
        }
    }, []);

    useEffect(() => {
        if (postpopup) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [postpopup, handleClickOutside]);

    //Api integration -> categories - Maximum speed optimization
    // Fetch categories and states on mount (doesn't need location)
    useEffect(() => {
        const fetchInitialData = async () => {
            setIsCategoriesLoading(true);

            try {
                const categoriesRes = await axios.get(`${BACKEND_URL}website/categories`, {
                    timeout: 10000,
                    headers: { 'Accept': 'application/json' },
                    withCredentials: false
                });

                const categoriesData = categoriesRes.data?.data || categoriesRes.data?.categories || (Array.isArray(categoriesRes.data) ? categoriesRes.data : []);
                setCategories(categoriesData);
                setIsCategoriesLoading(false);

                // Fetch states in parallel (non-blocking)
                axios.get(`${BACKEND_URL}website/get-master-data`, {
                    timeout: 8000,
                    withCredentials: false
                }).then(res => {
                    setStates(res.data?.stateData || []);
                }).catch(() => {
                    setStates([]);
                });

            } catch (error) {
                console.error("[Experience.js] ❌ [1/5] Categories API Error:", error.message);
                setCategories([]);
                setStates([]);
                setIsCategoriesLoading(false);
            }
        };

        fetchInitialData();
    }, []);


    // In your Experience component:

    // All location-dependent API calls are now in the sequential useEffect above


    // Memoize filtered offers to avoid recalculating on every render
    const topPicksOffers = useMemo(() =>
        offers.filter((offer) => offer.view_type === 1),
        [offers]
    );

    const trendingOffers = useMemo(() =>
        offers.filter((offer) => offer.view_type === 3),
        [offers]
    );

    const limitedTimeDeals = useMemo(() =>
        offers.filter((offer) => offer.view_type === 5),
        [offers]
    );

    // const enjoySummerBanners = useMemo(() =>
    //     offers.filter((offer) => offer.view_type === 2),
    //     [offers]
    // );
    // 2. Deduplicate enjoySummerBanners
    const enjoySummerBanners = useMemo(() => {
        const filtered = offers.filter((offer) => offer.view_type === 2);

        // Remove duplicates by ID using Map
        const uniqueMap = new Map();
        filtered.forEach(banner => {
            uniqueMap.set(banner.id, banner);
        });

        return Array.from(uniqueMap.values());
    }, [offers]);

    //ViewType === 6 - Split into first occurrence and remaining
    const viewType6Offers = useMemo(() => {
        return offers?.filter(offer => offer.view_type === 6) || [];
    }, [offers]);

    const firstViewType6 = useMemo(() => {
        return viewType6Offers.length > 0 ? [viewType6Offers[0]] : [];
    }, [viewType6Offers]);

    const remainingViewType6 = useMemo(() => {
        return viewType6Offers.length > 1 ? viewType6Offers.slice(1) : [];
    }, [viewType6Offers]);


    // Memoize top picks title
    const topPicksTitle = useMemo(() => {
        const topPick = topPicksOffers[0];
        return topPick?.title || "";
    }, [topPicksOffers]);

    // Memoize top picks title
    const trendingthisweekTitle = useMemo(() => {
        const trending = trendingOffers[0];
        return trending?.title || "";
    }, [trendingOffers]);

    // Memoize limited time deals title
    const limitedTimeDealsTitle = useMemo(() => {
        const deal = limitedTimeDeals[0];
        return deal?.title || "";
    }, [limitedTimeDeals]);

    // Memoize category-based coupons mapping
    const categoryCouponsMap = useMemo(() => {
        const map = new Map();
        categories.forEach(category => {
            const couponsForCategory = categorylist.filter(coupon => {
                if (!coupon.category || !Array.isArray(coupon.category) || coupon.category.length === 0) {
                    return false;
                }
                return coupon.category.some(cat => cat && cat.category === category.id);
            });
            if (couponsForCategory.length > 0) {
                map.set(category.id, { category, coupons: couponsForCategory });
            }
        });
        return map;
    }, [categories, categorylist]);


    useEffect(() => {
        // Function to scroll to top
        const scrollToTop = () => {
            const middleSection = document.querySelector('.experience-middle-section');
            if (middleSection) {
                middleSection.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        };

        // Add event listener to home icon
        const homeIcon = document.querySelector('.homepage-icons a[href="/experience"]');
        if (homeIcon) {
            homeIcon.addEventListener('click', scrollToTop);
        }

        // Cleanup
        return () => {
            if (homeIcon) {
                homeIcon.removeEventListener('click', scrollToTop);
            }
        };
    }, [])

    // Handle single-card carousels - add class when only one slide exists
    const handleSingleCardCarousels = useCallback(() => {
        const carouselSections = [
            '.unlimited-offers-section',
            '.discover-category-section',
            '.top-pick-div-carousel',
            '.limited-deals-carousel'
        ];

        carouselSections.forEach(selector => {
            const sections = document.querySelectorAll(selector);
            sections.forEach(section => {
                const slider = section.querySelector('.slick-slider');
                if (slider) {
                    // Check for actual slides (excluding cloned ones)
                    const slides = slider.querySelectorAll('.slick-slide:not(.slick-cloned)');
                    const actualSlides = Array.from(slides).filter(slide => {
                        // Filter out any slides that are hidden or have no content
                        return slide.style.display !== 'none' && slide.querySelector('div');
                    });

                    if (actualSlides.length === 1) {
                        section.classList.add('single-card');
                    } else {
                        section.classList.remove('single-card');
                    }
                }
            });
        });
    }, []);

    useEffect(() => {
        // Run after carousels are initialized (slick needs time to render)
        const timeoutId = setTimeout(handleSingleCardCarousels, 300);

        // Also use MutationObserver to detect when slick initializes
        const observer = new MutationObserver(() => {
            handleSingleCardCarousels();
        });

        // Observe the main container for changes
        const mainSection = document.querySelector('.experience-middle-section');
        if (mainSection) {
            observer.observe(mainSection, {
                childList: true,
                subtree: true
            });
        }

        // Re-check on window resize with debounce
        const debouncedResize = debounce(handleSingleCardCarousels, 200);
        window.addEventListener('resize', debouncedResize);

        return () => {
            clearTimeout(timeoutId);
            observer.disconnect();
            window.removeEventListener('resize', debouncedResize);
        };
    }, [categories, offers, categorylist, handleSingleCardCarousels])

    return (
        <div>
            {/* <nav className="navbar">
                <div className="navbar-brand">
                    <a href="/">
                        <img src={hayatin} alt="hayatin" />
                    </a>
                </div>

                <div className="homepage-icons">
                    <Link to="/">
                        <img src={homeicon} alt="homeicon" />
                    </Link>

                    <Link to="/experience">
                        <img src={experienceicon} alt="experienceicon" />
                    </Link>
                    <Link to="/business&brands">
                        <img src={businessicon} alt="businessicon" />
                    </Link>

                </div>

                <div className="registerbtn-icons">
                    <div className="register-business">
                        <a href="https://www.hayatinapp.com/vendor/register" >
                            <button className="register-business-btn">
                                Register Your Business
                            </button>
                        </a>
                    </div>
                    <div className="notificationicons">
                        <img src={plusicon} alt="plusicon" onClick={() => setPostpopup(true)} />
                        <img src={messageicon} alt="messageicon" />
                        <img src={bellicon} alt="bellicon" />
                        <img src={profileicon} alt="profileicon" />
                    </div>

                </div>

            </nav> */}
            <Navbar
                selectedState={selectedState}
                onStateChange={handleStateChange}
                states={states}
                showLocationSelector={true}
            />

            <div className="experience-main-layout">
                <aside className={`left-section ${isSearchFocused || showDropdown ? 'search-active' : ''}`}>
                    <div className="searchbox-wrapper">
                        <div className="searchbox desktop-search" ref={searchBoxRef}>
                            <img src={search} alt="search" />
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchText}
                                onChange={handleSearchChange}
                                onKeyDown={handleSearchEnter}
                                onFocus={() => {
                                    setIsSearchFocused(true);
                                    if (searchText.trim().length > 0 && (vendorList.length > 0 || searchCoupons.length > 0 || searchEvents.length > 0)) {
                                        setShowDropdown(true);
                                    }
                                }}
                                onBlur={() => {
                                    setTimeout(() => {
                                        setIsSearchFocused(false);
                                    }, 200);
                                }}
                            />
                            {searchText && searchText.trim().length > 0 && (
                                <img
                                    src={xmark}
                                    alt="clear"
                                    className="search-clear-icon"
                                    onClick={handleClearSearch}
                                    style={{ cursor: "pointer", display: "block" }}
                                />
                            )}
                        </div>
                    </div>

                    {/* Search results dropdown */}
                    {showDropdown && searchText.trim().length > 0 && (
                        <div className="vendor-list-container" ref={searchDropdownRef}>
                            {isSearchLoading ? (
                                <div className="vendor-list-loading">Loading...</div>
                            ) : (
                                <>
                                    {/* Display Vendors */}
                                    {vendorList.length > 0 && vendorList.map((vendor, index) => {
                                        const vendorId = vendor.user_id || vendor.vendor_id || vendor.id;
                                        const vendorName = vendor.vendor_name || vendor.user_name || vendor.name || "Unknown Vendor";
                                        const vendorImage = vendor.user_image || vendor.vendor_cover_image || vendor.profile_image || "";
                                        const userType = String(vendor.user_type || vendor.userType || "");
                                        const isUserTypeZero = userType === "0";

                                        return (
                                            <div
                                                key={vendorId || index}
                                                className="vendor-list-item"
                                                onClick={() => {
                                                    handleVendorSelect(vendor);
                                                    navigate(`/searchpage/${vendorId}`);
                                                }}
                                            >
                                                <div className="vendor-list-content">
                                                    {vendorImage && vendorImage.trim() !== '' ? (
                                                        <img
                                                            src={vendorImage}
                                                            alt={vendorName}
                                                            className={`vendor-list-image ${isUserTypeZero ? 'vendor-list-image-circle' : 'vendor-list-image-square'}`}
                                                        />
                                                    ) : (
                                                        <div className={`vendor-list-initial ${isUserTypeZero ? 'vendor-list-initial-circle' : 'vendor-list-initial-square'}`}>
                                                            {vendorName ? vendorName.charAt(0).toUpperCase() : '?'}
                                                        </div>
                                                    )}
                                                    <span className="vendor-list-name">{vendorName}</span>
                                                </div>
                                                <Link
                                                    to={isUserTypeZero ? `/userprofile/${vendorId}` : `/vendordetails/${vendorId}`}
                                                    className="vendor-view-profile-btn remove-underline"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleVendorSelect(vendor);
                                                    }}
                                                >
                                                    View Profile
                                                </Link>
                                            </div>
                                        );
                                    })}

                                    {/* Display Coupons (Offers) */}
                                    {searchCoupons.length > 0 && searchCoupons.map((coupon, index) => {
                                        const couponId = coupon.coupon_id;
                                        const userId = coupon.user_id;
                                        const userName = coupon.user_name || "Unknown Vendor";
                                        const userImage = coupon.user_image || "";
                                        const categoryId = coupon.category?.[0]?.category || 0;

                                        return (
                                            <div
                                                key={`coupon-${couponId || index}`}
                                                className="vendor-list-item"
                                                onClick={() => {
                                                    navigate(`/offers/${couponId}/${categoryId}`);
                                                    setShowDropdown(false);
                                                    setSearchText("");
                                                }}
                                            >
                                                <div className="vendor-list-content">
                                                    {userImage && userImage.trim() !== '' ? (
                                                        <img
                                                            src={userImage}
                                                            alt={userName}
                                                            className="vendor-list-image vendor-list-image-square"
                                                        />
                                                    ) : (
                                                        <div className="vendor-list-initial vendor-list-initial-square">
                                                            {userName ? userName.charAt(0).toUpperCase() : '?'}
                                                        </div>
                                                    )}
                                                    <span className="vendor-list-name">{userName}</span>
                                                </div>
                                                <span className="vendor-offer-text">Offer</span>
                                            </div>
                                        );
                                    })}

                                    {/* Display Events */}
                                    {searchEvents.length > 0 && searchEvents.map((event, index) => {
                                        const eventId = event.event_id;
                                        const eventTitle = event.title || "Unknown event";
                                        const eventImage = event.event_image || "";

                                        return (
                                            <div
                                                key={`event-${eventId || index}`}
                                                className="vendor-list-item"
                                                onClick={() => {
                                                    navigate(`/eventdetails/${eventId}`);
                                                    setShowDropdown(false);
                                                    setSearchText("");
                                                }}
                                            >
                                                <div className="vendor-list-content">
                                                    {eventImage && eventImage.trim() !== '' ? (
                                                        <img
                                                            src={eventImage}
                                                            alt={eventTitle}
                                                            className="vendor-list-image vendor-list-image-square"
                                                        />
                                                    ) : (
                                                        <div className="vendor-list-initial vendor-list-initial-square">
                                                            {eventTitle ? eventTitle.charAt(0).toUpperCase() : '?'}
                                                        </div>
                                                    )}
                                                    <span className="vendor-list-name">{eventTitle}</span>
                                                </div>
                                                <span className="vendor-offer-text">Event</span>
                                            </div>
                                        );
                                    })}

                                    {/* No results message */}
                                    {vendorList.length === 0 && searchCoupons.length === 0 && searchEvents.length === 0 && !isSearchLoading && (
                                        <div className="vendor-list-loading">No results found</div>
                                    )}
                                </>
                            )}
                        </div>
                    )}

                    {/* Hide left-menu-content and left-bottom-links when search is focused or dropdown is shown */}
                    {!(isSearchFocused || showDropdown) && (
                        <>
                            <div className="left-menu-content">
                                {/* <div className="img-contentname">
                                    <img src={videos} alt="videos" />
                                    <p>Videos for you</p>
                                </div> */}
                                <div className="img-contentname" onClick={() => setCountrypopup(true)}>
                                    <img src={getFlagIcon(selectedState || emirate)} alt="flag" className="flagicon" />
                                    <p>{selectedState?.name || emirate?.name || "Abu Dhabi"}</p>
                                </div>
                                {/* <div className="img-contentname">
                                                   <img src={blogs} alt="blogs" />
                                                   <p>Blogs</p>
                                               </div>
                                               <div className="img-contentname">
                                                   <img src={save} alt="save" />
                                                   <p>Saved</p>
                                               </div>
                                               <div className="img-contentname">
                                                   <img src={profileicon} alt="profileicon" />
                                                   <p>Profile</p>
                                               </div>
                                               <div className="img-contentname">
                                                   <img src={plusicon} alt="plusicon" />
                                                   <p>Post</p>
                                               </div>
                                               <div className="img-contentname">
                                                   <img src={menu} alt="menu" />
                                                   <p>Menu</p>
                                               </div> */}
                            </div>
                            <div className="divider-line"></div>
                            <div className="left-bottom-links">
                                <div className="download-app">
                                    <div className="hayaticon">
                                        <img src={hayatlogo} alt="Hayat In Logo" />
                                        {/* <a href="#close" className="close-btn">
                                                                <img src={xmark} alt="xmark" className="xmark" />
                                                            </a> */}
                                    </div>
                                    <h4>Download Hayat In App</h4>

                                    <div className="store-buttons">
                                        <div className="app_qr">
                                            <a
                                                href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img src={app_store} alt="App Store" />
                                            </a>

                                            <a
                                                href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img src={play_store} alt="Google Play" />
                                            </a>
                                        </div>


                                        <div className="app_qr">
                                            <img className="qr" src={qr} alt="QR code" />
                                        </div>
                                    </div>
                                </div>
                                <div className="divider-line"></div>

                                <div className="left-bottom1">
                                    <a href="/about">About Us</a>
                                    {/* <a href="#BusinessPro">Business Pro</a> */}
                                    <div className="content-arrow">
                                        <Link to="/merchantagreement" className="privacy-link">
                                            <span>Privacy & Terms</span>
                                            <img src={downarrow} alt="down arrow" />
                                        </Link>
                                    </div>
                                    <a href="/downloadpage">Download</a>
                                </div>
                                {/* <div className="left-bottom1">
                                                   <a href="#help-center">Help Center</a>
                                                   <a href="#FAQ">FAQ</a>
                                                   <a href="#Careers">Careers</a>
                                               </div>
                                               <div className="left-bottom1">
                                                   <div className="content-arrow">
                                                       <Link to="/merchantagreement" className="privacy-link">
                                                           <span>Privacy & Terms</span>
                                                           <img src={downarrow} alt="down arrow" />
                                                       </Link>
                                                   </div>
                                                   <div className="content-arrow">
                                                       <a href="#Languages">Language</a>
                                                       <img src={downarrow} alt="downarrow" />
                                                   </div>
                                               </div> */}
                            </div>
                        </>
                    )}
                </aside>

                <main className="experience-middle-section">
                    {/* center section video - FIRST */}
                    <div className="center-video">
                        <video
                            autoPlay
                            muted
                            loop
                            playsInline
                            className="video">
                            <source src={exploreabudhabi} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>

                    {/* Discover by category and its carousel - SECOND */}
                    <div className="discover-category" onClick={() => setIsPopupOpen(true)}>
                        <h4>Discover by Category</h4>
                        <img src={rightarrow} alt="rightarrow" className="rightarrow" />
                    </div>

                    {isCategoriesLoading ? (
                        <div className="discover-category-section">
                            <div className="shimmer-category-container">
                                {Array.from({ length: 4 }).map((_, index) => (
                                    <div key={`shimmer-category-${index}`} className="shimmer-category-card">
                                        <div className="shimmer-category-inner">
                                            <div className="shimmer-category-image"></div>
                                            <div className="shimmer-category-text"></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : categories.length > 0 && (
                        <div className="discover-category-section">
                            <Slider {...discoverdata}>
                                {categories.map((item) => (
                                    <div key={item.id}>
                                        <Link
                                            to={`/categorylist/${item.id}`}
                                            className="remove-underline"
                                        >
                                            <div className="discover-carousel-card">
                                                <div className="discover-card-inner">
                                                    <img
                                                        src={item.image}
                                                        alt={item.category_name}
                                                        loading="lazy"
                                                        onError={(e) => {
                                                            e.target.src = "/no-image.png";
                                                        }}
                                                    />
                                                    <p>{item.category_name}</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    )}

                    {/* week spotlights and its carousel */}
                    {/* {isSpotlightsLoading ? (
                        <>
                            <div className="Weekly-Spotlights">
                                <div className="shimmer-title-line"></div>
                                <div className="circlearrows">
                                    <div className="shimmer-circle-arrow"></div>
                                    <div className="shimmer-circle-arrow"></div>
                                </div>
                            </div>
                            <div className="weekly-spotlight-carousel-container">
                                <div className="shimmer-spotlight-container">
                                    {Array.from({ length: 4 }).map((_, index) => (
                                        <div key={`shimmer-spotlight-${index}`} className="shimmer-spotlight-card">
                                            <div className="shimmer-spotlight-background"></div>
                                            <div className="shimmer-spotlight-overlay">
                                                <div className="shimmer-spotlight-avatar"></div>
                                                <div className="shimmer-spotlight-name"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    ) : spotlights.length > 0 && (
                        <>
                            <div className="Weekly-Spotlights">
                                <h4>Weekly Spotlights</h4>
                                <div className="circlearrows">
                                    <img
                                        src={circleleftarrow}
                                        alt="circleleft"
                                        onClick={() => sliderRef.current?.slickPrev()}
                                    />
                                    <img
                                        src={circlerightarrow}
                                        alt="circleright"
                                        onClick={() => sliderRef.current?.slickNext()}
                                    />
                                </div>
                            </div>

                            <div className="weekly-spotlight-carousel-container">
                                <Slider ref={sliderRef} {...Weeklyspotlightdata} className="weekly-spotlight-slider">
                                    {spotlights.map((item, index) => {
                                        const mediaItem = item.media?.[0];
                                        if (!mediaItem) return null;

                                        return (
                                            <Link to={`/spotlights/${item.user_id}?spotlight_id=${item.id}`} key={index}>
                                                <div className="carousel-card spotlight">

                                                    {mediaItem.media_type === "video" ? (
                                                        <video
                                                            className="weekly-spotlight-background-video"
                                                            autoPlay
                                                            muted
                                                            loop
                                                            style={{ width: "100%", objectFit: "cover" }}
                                                            loading="lazy"
                                                        >
                                                            <source src={mediaItem.media} type="video/mp4" />
                                                        </video>
                                                    ) : (
                                                        <div
                                                            className="weekly-spotlight-background-image"
                                                            style={{ backgroundImage: `url(${mediaItem.media})` }}
                                                        />
                                                    )}

                                                    <div className="weekly-spotlight-overlay-content">
                                                        <img 
                                                            src={item.user_image} 
                                                            alt="vendor cover" 
                                                            loading="lazy"
                                                            onError={(e) => {
                                                                e.target.src = "/no-image.png";
                                                            }}
                                                        />
                                                        <h4>{item.user_name}</h4>
                                                    </div>
                                                </div>
                                            </Link>
                                        );
                                    })}
                                </Slider>
                            </div>
                        </>
                    )} */}

                    {/* Top Picks */}
                    {isOffersLoading ? (
                        <>
                            <div className="Weekly-Spotlights">
                                <div className="shimmer-title-line"></div>
                                <div className="circlearrows">
                                    <div className="shimmer-circle-arrow"></div>
                                    <div className="shimmer-circle-arrow"></div>
                                </div>
                            </div>
                            <div className="top-pick-div-carousel">
                                <div className="shimmer-top-picks-container">
                                    {Array.from({ length: 4 }).map((_, index) => (
                                        <div key={`shimmer-top-pick-${index}`} className="shimmer-top-pick-card">
                                            <div className="shimmer-top-pick-image"></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    ) : topPicksOffers.length > 0 && (
                        <>
                            <div className="Weekly-Spotlights">
                                {topPicksTitle && <h4>{topPicksTitle}</h4>}
                                <div className="circlearrows">
                                    <img
                                        src={circleleftarrow}
                                        alt="circleleft"
                                        onClick={() => toppicksRef.current?.slickPrev()}
                                    />
                                    <img
                                        src={circlerightarrow}
                                        alt="circleright"
                                        onClick={() => toppicksRef.current?.slickNext()}
                                    />
                                </div>
                            </div>

                            <div className="top-pick-div-carousel">
                                <Slider ref={toppicksRef} {...unlimitedExperienceSettings}>
                                    {topPicksOffers.map((offer) =>
                                        offer.banners?.map((banner) => (
                                            <Link
                                                to={`/banners/${banner.banner_id}`}
                                                key={banner.banner_id}
                                                className="carousel-card"
                                            >
                                                <div className="top-pick-carousel">
                                                    <img
                                                        src={banner.banner_image || PLACEHOLDER_IMAGE}
                                                        alt="top-picks-item"
                                                        loading="lazy"
                                                        onError={(e)=>{
                                                            e.target.src = PLACEHOLDER_IMAGE
                                                        }}
                                                    />
                                                </div>
                                            </Link>
                                        ))
                                    )}
                                </Slider>
                            </div>
                        </>
                    )}


                    {/* Unlimited Offers Abu Dhabi */}
                    <div className="discover-category">
                        <Link to="/unlimitedoffers?tab=UnlimitedOffers" className="remove-underline">
                            <div className="discover-link">
                                <h4>New Offers in {selectedState?.name || effectiveEmirate?.name}</h4>
                                <img src={rightarrow} alt="rightarrow" className="rightarrow" />
                            </div>
                        </Link>
                    </div>

                    {isCategoryListLoading ? (
                        <div className="unlimited-offers-section">
                            <div className="shimmer-offers-container">
                                {Array.from({ length: 4 }).map((_, index) => (
                                    <div key={`shimmer-offer-${index}`} className="shimmer-offer-card">
                                        <div className="shimmer-offer-image"></div>
                                        <div className="shimmer-offer-details">
                                            <div className="shimmer-line shimmer-offer-location"></div>
                                            <div className="shimmer-line shimmer-offer-title"></div>
                                            <div className="shimmer-line shimmer-offer-distance"></div>
                                            <div className="shimmer-line shimmer-offer-price"></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : categorylist.length > 0 && (
                        <div className="unlimited-offers-section">
                            <Slider {...unlimitedExperienceSettings}>
                                {categorylist.map((item, index) => (
                                    <Link
                                        key={`${item.coupon_id}-${index}`}
                                        to={`/offers/${item.coupon_id}/${item.category[0]?.category}`}
                                        className="remove-underline"
                                    >
                                        <div className="offer-card">
                                            <div className="offer-img-wrapper">
                                                <img
                                                    src={item.coupon_image || PLACEHOLDER_IMAGE}
                                                    alt={item.coupon_title || "offer"}
                                                    loading="lazy"
                                                    onError={(e)=>{
                                                        e.target.src = PLACEHOLDER_IMAGE
                                                    }}
                                                />
                                            </div>
                                            <div className="offer-details">
                                                <p className="offer-location">
                                                    <span>
                                                        <img src={businessicon} alt="logo" className="bussinessicon" />
                                                    </span>
                                                    <span>{item.user_name}</span>
                                                </p>
                                                <h4>{item.coupon_title}</h4>
                                                <p className="limited-deals-distance">
                                                    {item.distance?.toFixed(1)} km | {item.location}
                                                </p>
                                                <div className="offer-prices">{getDiscountText(item)}</div>
                                            </div>
                                        </div>
                                    </Link>
                                ))}
                            </Slider>
                        </div>
                    )}


                    {/* Near You */}
                    <div className="discover-category">
                        <Link to="/nearyou" className="remove-underline">
                            <div className="discover-link">
                                <h4>Near You</h4>
                                <img src={rightarrow} alt="rightarrow" className="rightarrow" />
                            </div>
                        </Link>
                    </div>

                    {isNearMeLoading ? (
                        <div className="unlimited-offers-section">
                            <div className="shimmer-offers-container">
                                {Array.from({ length: 4 }).map((_, index) => (
                                    <div key={`shimmer-offer-${index}`} className="shimmer-offer-card">
                                        <div className="shimmer-offer-image"></div>
                                        <div className="shimmer-offer-details">
                                            <div className="shimmer-line shimmer-offer-location"></div>
                                            <div className="shimmer-line shimmer-offer-title"></div>
                                            <div className="shimmer-line shimmer-offer-distance"></div>
                                            <div className="shimmer-line shimmer-offer-price"></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : nearme.length > 0 && (
                        <div className="unlimited-offers-section">
                            <Slider {...unlimitedExperienceSettings}>
                                {nearme.map((item, index) => (
                                    <Link
                                        key={`${item.coupon_id}-${index}`}
                                        to={`/offers/${item.coupon_id}/${item.category[0]?.category}`}
                                        className="remove-underline"
                                    >
                                        <div className="offer-card">
                                            <div className="offer-img-wrapper">
                                                <img
                                                    src={item.coupon_image || PLACEHOLDER_IMAGE}
                                                    alt={item.coupon_title || "offer"}
                                                    loading="lazy"
                                                    onError={(e)=>{
                                                        e.target.src = PLACEHOLDER_IMAGE
                                                    }}
                                                />
                                            </div>
                                            <div className="offer-details">
                                                <p className="offer-location">
                                                    <span>
                                                        <img src={businessicon} alt="logo" className="bussinessicon" />
                                                    </span>
                                                    <span>{item.user_name}</span>
                                                </p>
                                                <h4>{item.coupon_title}</h4>
                                                <p className="limited-deals-distance">
                                                    {item.distance?.toFixed(1)} km | {item.location}
                                                </p>
                                                <div className="offer-prices">{getDiscountText(item)}</div>
                                            </div>
                                        </div>
                                    </Link>
                                ))}
                            </Slider>
                        </div>
                    )}


                    {/* First ViewType 6 (Hotel Luxury) - Initial ID */}
                    {firstViewType6?.map(section => {
                        const userItems = section.user_items || [];
                        // Chunk items: 9 for desktop (3x3), 1 for mobile
                        const isMobile = windowWidth <= 768;
                        const chunkSize = isMobile ? 3 : 9;
                        const chunks = chunkArray(userItems, chunkSize);

                        return (
                            <div key={section.id} className="hotel-section-wrapper">
                                {/* Title Row */}
                                <div className="discover-category">
                                    <Link to={`/experiencelist/${section.id}`} className="remove-underline">
                                        <div className="discover-link">
                                            <h4>{section.title}</h4>
                                            <img src={rightarrow} alt="rightarrow" className="rightarrow" />
                                        </div>
                                    </Link>
                                </div>

                                {/* Subtitle */}
                                <div className="hotel-data-div">
                                    <p className="viewtype-6-subtitle">{section.subtitle}</p>

                                    {/* Slider Carousel */}
                                    <div className="hotel-slider-container">
                                        <Slider {...viewType6SliderSettings}>
                                            {chunks.map((chunk, chunkIndex) => (
                                                <div key={chunkIndex} className="hotel-slide">
                                                    <div className="hotel-cards-grid">
                                                        {chunk.map(user => (
                                                            <Link
                                                                to={`/vendordetails/${user.user_id}`}
                                                                className="remove-underline hotel-title-link"
                                                            >
                                                                <div key={user.user_id} className="hotel-data-cardwrapper">
                                                                    <img
                                                                        src={user.user_image || PLACEHOLDER_IMAGE}
                                                                        className="hotels-luxury-image"
                                                                        alt={user.user_name}
                                                                        loading="lazy"
                                                                        onError={(e)=>{
                                                                            e.target.src = PLACEHOLDER_IMAGE
                                                                        }}
                                                                    />
                                                                    <div className="hotel-luxury-data">
                                                                        <p className="limited-deals-title hotel-luxury">
                                                                            {user.user_name}
                                                                        </p>
                                                                        <p className="limited-deals-distance">
                                                                            {user.distance?.toFixed(1) || 0} km | {user.location}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        );
                    })}




                    {/* Trending this week */}
                    {isOffersLoading ? (
                        <>
                            <div className="discover-category">
                                <div className="shimmer-title-line"></div>
                                <div className="shimmer-arrow"></div>
                            </div>
                            <div className="unlimited-offers-section">
                                <div className="shimmer-offers-container">
                                    {Array.from({ length: 4 }).map((_, index) => (
                                        <div key={`shimmer-trending-${index}`} className="shimmer-offer-card">
                                            <div className="shimmer-offer-image"></div>
                                            <div className="shimmer-offer-details">
                                                <div className="shimmer-line shimmer-offer-location"></div>
                                                <div className="shimmer-line shimmer-offer-title"></div>
                                                <div className="shimmer-line shimmer-offer-distance"></div>
                                                <div className="shimmer-line shimmer-offer-price"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    ) : trendingOffers.length > 0 && (
                        <>
                            <div className="discover-category">
                                <Link to="/unlimitedoffers?tab=TrendingThisWeek" className="remove-underline">
                                    <div className="discover-link">
                                        {trendingthisweekTitle && <h4>{trendingthisweekTitle}</h4>}
                                        <img src={rightarrow} alt="rightarrow" className="rightarrow" />
                                    </div>
                                </Link>
                            </div>


                            <div className="unlimited-offers-section">
                                <Slider {...unlimitedExperienceSettings}>
                                    {trendingOffers.map((trendingthisweek) =>
                                        trendingthisweek.offer_items?.map((item, index) => (
                                            <Link
                                                key={`${item.coupon_id}-${index}`}
                                                to={`/offers/${item.coupon_id}/${item.category_id}`}
                                                className="remove-underline"
                                            >
                                                <div className="offer-card">
                                                    <div className="offer-img-wrapper">
                                                        <img
                                                            src={item.coupon_image || PLACEHOLDER_IMAGE}
                                                            alt={item.coupon_title || "trending offer"}
                                                            loading="lazy"
                                                            onError={(e)=>{
                                                                e.target.src = PLACEHOLDER_IMAGE
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="offer-details">
                                                        <p className="offer-location">
                                                            <span><img src={businessicon} alt="logo" className="bussinessicon" /></span>
                                                            <span>{item.user_name}</span>
                                                        </p>
                                                        <h4>{item.coupon_title}</h4>
                                                        <div className="kilometer-location">
                                                            <p className="offer-distance">{item.distance?.toFixed(1) || 0} km</p>
                                                            <span>|</span>
                                                            <p className="offer-location">{item.location}</p>
                                                        </div>
                                                        <div className="offer-prices">{getDiscountText(item)}</div>
                                                    </div>
                                                </div>
                                            </Link>
                                        ))
                                    )}
                                </Slider>
                            </div>
                        </>
                    )}

                    {/*Limited time deals  */}
                    {isOffersLoading ? (
                        <>
                            <div className="discover-category">
                                <div className="shimmer-title-line"></div>
                                <div className="shimmer-arrow"></div>
                            </div>
                            <div className="limited-deals-carousel">
                                <div className="shimmer-limited-deals-container">
                                    {Array.from({ length: 3 }).map((_, index) => (
                                        <div key={`shimmer-limited-deal-${index}`} className="shimmer-limited-deal-card">
                                            <div className="shimmer-limited-deal-image"></div>
                                            <div className="shimmer-limited-deal-info">
                                                <div className="shimmer-line shimmer-limited-deal-vendor"></div>
                                                <div className="shimmer-line shimmer-limited-deal-title"></div>
                                                <div className="shimmer-line shimmer-limited-deal-distance"></div>
                                                <div className="shimmer-limited-deal-tag"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    ) : limitedTimeDeals.length > 0 && (
                        <>
                            <div className="discover-category">
                                <Link to="/unlimitedoffers?tab=LimitedTimeDeals" className="remove-underline">
                                    <div className="discover-link">
                                        {limitedTimeDealsTitle && <h4>{limitedTimeDealsTitle}</h4>}
                                        <img src={rightarrow} alt="rightarrow" className="rightarrow" />
                                    </div>
                                </Link>
                            </div>

                            <div className="limited-deals-carousel">
                                <Slider {...limitedtimedealsdata}>
                                    {limitedTimeDeals.map((limitedtimedeals) =>
                                        limitedtimedeals.offer_items?.map((item, index) => (
                                            <Link
                                                key={`${item.coupon_id}-${index}`}
                                                to={`/offers/${item.coupon_id}/${item.category_id}`}
                                                className="remove-underline"
                                            >
                                                <div className="limited-deals-slide">
                                                    <div className="limited-deals-card">
                                                        <div className="limited-deals-image">
                                                            <img
                                                                src={item.coupon_image || PLACEHOLDER_IMAGE}
                                                                alt={item.coupon_title || "limited-deal"}
                                                                loading="lazy"
                                                                onError={(e)=>{
                                                                    e.target.src = PLACEHOLDER_IMAGE
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="limited-deals-info">
                                                            <div className="limited-deal-business-vendor-heart-div">
                                                                <div className="limited-deals-vendor-row">
                                                                    <img src={businessicon1} className="businessicon" alt="business" />
                                                                    <p className="limited-deals-subtitle">{item.user_name}</p>
                                                                </div>
                                                            </div>
                                                            <p className="limited-deals-title">{item.coupon_title}</p>
                                                            <p className="limited-deals-distance">
                                                                {item.distance?.toFixed(1) || 0} km | {item.location}
                                                            </p>
                                                            <div className="limited-deals-tag-div">
                                                                {getDiscountText(item, "limited-deals-tag")}
                                                            </div>
                                                        </div>
                                                        <div className="limited-deals-extra">
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        ))
                                    )}
                                </Slider>
                            </div>
                        </>
                    )}

                    {/* Enjoy Summer Image (Banners - view_type 2) */}
                    {enjoySummerBanners.length > 0 && enjoySummerBanners.map((offer) =>
                        offer.banners?.map((banner) => (
                            <Link
                                to={`/banners/${banner.banner_id}`}
                                key={banner.banner_id}
                                className="carousel-card"
                            >
                                <div className="enjoy-summer">
                                    {banner.video ? (
                                        <video
                                            src={banner.video}
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            loading="lazy"
                                        />
                                    ) : (
                                        <img
                                            src={banner.banner_image}
                                            alt="banner"
                                            loading="lazy"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    )}
                                </div>
                            </Link>
                        ))
                    )}

                    {/* Remaining ViewType 6 sections */}
                    {remainingViewType6?.map(section => {
                        const userItems = section.user_items || [];
                        // Chunk items: 9 for desktop (3x3), 1 for mobile
                        const isMobile = windowWidth <= 768;
                        const chunkSize = isMobile ? 3 : 9;
                        const chunks = chunkArray(userItems, chunkSize);

                        return (
                            <div key={section.id} className="hotel-section-wrapper remainingviewtype6">
                                {/* Title Row */}
                                <div className="discover-category">
                                    <Link to={`/experiencelist/${section.id}`} className="remove-underline">
                                        <div className="discover-link">
                                            <h4>{section.title}</h4>
                                            <img src={rightarrow} alt="rightarrow" className="rightarrow" />
                                        </div>
                                    </Link>
                                </div>

                                {/* Subtitle */}
                                <div className="hotel-data-div">
                                    <p className="viewtype-6-subtitle">{section.subtitle}</p>

                                    {/* Slider Carousel */}
                                    <div className="hotel-slider-container">
                                        <Slider {...viewType6SliderSettings}>
                                            {chunks.map((chunk, chunkIndex) => (
                                                <div key={chunkIndex} className="hotel-slide">
                                                    <div className="hotel-cards-grid">
                                                        {chunk.map(user => (
                                                            <Link
                                                                to={`/vendordetails/${user.user_id}`}
                                                                className="remove-underline hotel-title-link"
                                                            >
                                                                <div key={user.user_id} className="hotel-data-cardwrapper">
                                                                    <img
                                                                        src={user.user_image || PLACEHOLDER_IMAGE}
                                                                        className="hotels-luxury-image"
                                                                        alt={user.user_name}
                                                                        loading="lazy"
                                                                        onError={(e)=>{
                                                                            e.target.src = PLACEHOLDER_IMAGE
                                                                        }}
                                                                    />
                                                                    <div className="hotel-luxury-data">
                                                                        <p className="limited-deals-title hotel-luxury">
                                                                            {user.user_name}
                                                                        </p>
                                                                        <p className="limited-deals-distance">
                                                                            {user.distance?.toFixed(1)} km | {user.location}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                    {/* Category-based coupons - using memoized map */}
                    {isCategoryListLoading ? (
                        Array.from({ length: 2 }).map((_, sectionIndex) => (
                            <div key={`shimmer-category-section-${sectionIndex}`} className="unlimited-offers-section">
                                <div className="category-names">
                                    <div className="shimmer-title-line"></div>
                                    <div className="shimmer-arrow"></div>
                                </div>
                                <div className="shimmer-offers-container">
                                    {Array.from({ length: 4 }).map((_, index) => (
                                        <div key={`shimmer-category-offer-${sectionIndex}-${index}`} className="shimmer-offer-card">
                                            <div className="shimmer-offer-image"></div>
                                            <div className="shimmer-offer-details">
                                                <div className="shimmer-line shimmer-offer-location"></div>
                                                <div className="shimmer-line shimmer-offer-title"></div>
                                                <div className="shimmer-line shimmer-offer-distance"></div>
                                                <div className="shimmer-line shimmer-offer-price"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))
                    ) : (
                        Array.from(categoryCouponsMap.values()).map(({ category, coupons }) => (
                            <div key={category.id} className="unlimited-offers-section">
                                <div className="category-names">
                                    <Link to={`/categorylist/${category.id}`} className="remove-underline">
                                        <div className="discover-link">
                                            <h4>{category.category_name}</h4>
                                            <img src={rightarrow} alt="rightarrow" className="rightarrow" />
                                        </div>
                                    </Link>
                                </div>

                                <Slider {...unlimitedExperienceSettings}>
                                    {coupons.map((item, index) => (
                                        <Link
                                            key={`${item.coupon_id}-${index}`}
                                            to={`/offers/${item.coupon_id}/${item.category[0]?.category}`}
                                            className="remove-underline"
                                        >
                                            <div className="offer-card">
                                                <div className="offer-img-wrapper">
                                                    <img
                                                        src={item.coupon_image || PLACEHOLDER_IMAGE}
                                                        alt={item.coupon_title || "offer"}
                                                        loading="lazy"
                                                        onError={(e)=>{
                                                            e.target.src = PLACEHOLDER_IMAGE
                                                        }}
                                                    />
                                                </div>
                                                <div className="offer-details">
                                                    <p className="offer-location">
                                                        <img src={businessicon} alt="logo" className="bussinessicon" />
                                                        <span>{item.user_name}</span>
                                                    </p>
                                                    <h4>{item.coupon_title}</h4>
                                                    <p className="limited-deals-distance">
                                                        {item.distance?.toFixed(1) || 0} km | {item.location}
                                                    </p>
                                                    <div className="offer-prices">{getDiscountText(item)}</div>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </Slider>
                            </div>
                        ))
                    )}

                </main>
                {/* Discover category Popup Drawer */}
                {
                    isPopupOpen && (
                        <>
                            <div className="overlay" onClick={() => setIsPopupOpen(false)}></div>
                            <div className="popup-drawer">
                                <div className="popup-header">
                                    <h4>Categories</h4>
                                    <img src={xmark} alt="xmark" className="close-popup" onClick={() => setIsPopupOpen(false)} />
                                </div>
                                {categories.map((item) => (
                                    <div className="category-list" key={item.id}>
                                        <Link to={`/categorylist/${item.id}`} className="remove-underline">
                                            <div className="category-content">
                                                <div className="category-list-img">
                                                    <img
                                                        src={item.image}
                                                        alt={item.category_name}
                                                        loading="lazy"
                                                    />
                                                </div>
                                                <h6>{item.category_name}</h6>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </>
                    )
                }

                {/* Country pop up */}
                {countrypopup && (
                    <>
                        {/* Overlay */}
                        <div className="custom-overlay" onClick={() => setCountrypopup(false)}></div>

                        {/* Centered Popup */}
                        <div className="custom-popup">
                            <div className="custom-popup-header">
                                <h4>Choose Your Location</h4>
                                <img src={xmark} alt="close" className="close-popup" onClick={() => setCountrypopup(false)} />
                            </div>

                            {/* States List */}
                            <div className="custom-popup-body">
                                <div className="state-grid">
                                    {(() => {
                                        // Filter and sort states: Abu Dhabi, Dubai, Toronto, then others
                                        const filteredStates = states.filter((state) => Number(state.country_id));

                                        // Sort states: Abu Dhabi (1), Dubai (2), Toronto (9), then others
                                        const sortedStates = [...filteredStates].sort((a, b) => {
                                            // Abu Dhabi first
                                            if (a.id === 1) return -1;
                                            if (b.id === 1) return 1;
                                            // Dubai second
                                            if (a.id === 2) return -1;
                                            if (b.id === 2) return 1;
                                            // Toronto third (right after Dubai)
                                            if (a.id === 9) return -1;
                                            if (b.id === 9) return 1;
                                            // Rest maintain original order
                                            return a.id - b.id;
                                        });

                                        return sortedStates.map((state, index, arr) => {
                                            // Disable last 4 items, but exclude Toronto from being disabled
                                            const isToronto = state.id === 9;
                                            const isDisabled = !isToronto && index >= arr.length - 4;

                                            // Determine flag icon: Abu Dhabi, Dubai use flagicon
                                            // Others use countryicons array (Oman, Qatar, Kuwait, KSA)
                                            // Toronto doesn't get any flag icon
                                            let flagSrc = flagicon;
                                            if (state.id === 9) flagSrc = countryicons[0]; //Canada
                                            else if (state.id === 5) flagSrc = countryicons[1]; // Oman
                                            else if (state.id === 6) flagSrc = countryicons[2]; // Qatar
                                            else if (state.id === 7) flagSrc = countryicons[3]; // Kuwait
                                            else if (state.id === 8) flagSrc = countryicons[4]; // KSA

                                            return (
                                                <div
                                                    key={state.id}
                                                    className={`state-item ${isDisabled ? "disabled" : ""}`}
                                                    onClick={() => !isDisabled && handleStateChange(state)}
                                                >

                                                    <img
                                                        src={flagSrc}
                                                        alt="flag"
                                                        className="flagicon-popup"
                                                    />

                                                    <p>{state.name}</p>
                                                </div>
                                            );
                                        });
                                    })()}
                                </div>
                            </div>
                        </div>
                    </>
                )
                }

                {postpopup && (
                    <div className="popup-overlay" onClick={() => setPostpopup(false)}>
                        <div className="popup-box" ref={popupRef} onClick={(e) => e.stopPropagation()}>

                            <div className="popup-options">
                                <Link to="/HomeCarouselOffer" className="remove-underline">
                                    <div className="popup-item">
                                        <img src={campopup} alt="Post" />
                                        <p>Post</p>
                                    </div>
                                </Link>

                                <div className="popup-item">
                                    <img src={vidpopup} alt="Video" />
                                    <p>Video</p>
                                </div>

                                <div className="popup-item">
                                    <img src={carouselpopup} alt="Carousel" />
                                    <p>Carousel</p>
                                </div>

                                <div className="popup-item">
                                    <img src={offerpopup} alt="Offer" />
                                    <p>Offer</p>
                                </div>

                                <div className="popup-item">
                                    <img src={spotlightpopup} alt="Spotlight" />
                                    <p>Spotlight</p>
                                </div>

                                <div className="popup-item">
                                    <img src={eventpopup} alt="Event" />
                                    <p>Event</p>
                                </div>

                            </div>
                        </div>
                    </div>
                )}



            </div >

        </div >
    );
}

export default Experience